<template>
  <dl class="w-100">
    <dt>Type:</dt>
    <dd>{{ latestMandate.paymentMethodType }}</dd>
    <template v-if="latestMandate.bankAccount">
      <dt>Account Name:</dt>
      <dd>{{ latestMandate.bankAccount.accountName }}</dd>
      <dt>Account Number:</dt>
      <dd>{{ latestMandate.bankAccount.accountNumber }}</dd>
      <dt>Sort Code:</dt>
      <dd>{{ latestMandate.bankAccount.sortCode }}</dd>
    </template>
  </dl>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { IDirectDebit } from "@/models/directDebit/directDebit.types"

  export default defineComponent({
    props: {
      latestMandate: {
        type: Object as PropType<IDirectDebit>,
        required: true,
      },
    },
  })
</script>

<style scoped>
  dt:before {
    content: "";
    display: block;
  }
  dt,
  dd {
    margin-right: 5px;
    display: inline;
  }
</style>
